import styled from 'styled-components';
import Popup from 'reactjs-popup';

export const ModalContent = styled.div`
`; 

export const ModalShadingWrap = styled.div`
width: 100%;
`;

export const ShadingMenuTitle = styled.div`
		color: var(--labelValueColor);
		font-size: 1.25rem;
		font-family: 'Inter';
		font-weight: 500;
`;

export const ShadingPopupMenu = styled(Popup)`
  &-overlay {
    background: rgba(0, 0, 0, 0.15); /* Dark overlay background */
  }

  &-content {
    position: fixed !important;
    top: 0;
    right: 0;
    height: 100vh;
    width: 386px;
    overflow: hidden;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    transition: transform 0.3s ease-in-out;
    transform: translateX(100%); /* Initially hide the modal off-screen to the right */
		border:none;
		padding: .85rem 0rem 1rem 0rem;
    &.open-content {
      transform: translateX(0); /* Slide in when open */
			background: var(--surfaceLightColor);
    }

    &.close-content {
      transform: translateX(100%); /* Slide out when closed */
    }

  }
`;

export const ShadingWrapper = styled.div`
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: .75rem;
	padding: 4px 1rem 1rem;
	min-height:36px;
	border-bottom: 1px solid var(--borderLightColor);
`;

export const ShadingTitle = styled.div`
		color: var(--labelValueColor);
		font-size: 1.25rem;
		font-family: 'Inter';
		font-weight: 500;
`;

export const ShadingTitleButtons = styled.div`
		display: flex;
		gap: .5rem;

		.btn-reset{
				background: var(--defaultBgColor);
				color: var(--textTitleColor);
				border: 1px solid var(--borderColor);
		}
`;

export const ModalShadingInfoWrap = styled.div`
		overflow-y: auto;
		height: calc(100vh - 100px);
		padding: .5rem 1rem;
		
`;

export const ShadingSliderWrap = styled.div` 
		color: var(--textTitleColor);
    font-family: 'Inter';
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
		gap: 5px;
		margin-bottom: 8px;
		width: 100%;


		label{
			font-size: 14px;
			line-height:16px;
			font-family: 'Inter';
  		font-weight: 500;
			color: var(--labelValueColor);
		}

		.shading-percentage{
			font-size: 14px;
			line-height: 16px;
			font-weight: 500;
			position: relative;
			color: var(--primary);
		}
`;

export const DivRevertWrap = styled.div`
	width: 100%;
	padding-top 24px;
	display: flex;
	justify-content:center;
`; 

export const CardInfoWrap = styled.div`
		background: var(--defaultBgColor);
    border: 1px solid var(--borderColor);
    padding: 1rem;
    border-radius: 12px;
		transition: 0.25s;
		transition: all 0.25s ease;

		&:hover {
			box-shadow: 0 4px 8px rgba(0,0,0,0.08);
		}

		&.active {
			background: var(--activeBgColor);
			border: 1px solid #7da2ff;
			box-shadow: 0 4px 8px rgba(125,162,255,0.25);
		}

		&.edited {
			border: 1px dashed #7DA2FF;
		}

		&.edited.active {
			background: var(--activeBgColor);
		}
`;

export const FacetPropsKeyValue = styled.div` 
		color: var(--textTitleColor);
		font-weight: 500;
		font-size: 14px;
		line-height: 16px;
		
		display: flex;
		justify-content: flex-start;
		align-items: center;
		margin-bottom: 0.5rem;
		gap: 5px;

		label{
			font-size: 14px;
			line-height: 16px;
		}

		span{
			font-size: 14px;
			line-height: 16px;
			font-weight: 600;
			position: relative;
			color: var(--labelValueColor);
		}
`;

export const SystemDivWrap = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex-wrap: wrap;
	background: var(--shadingArrayBgColor);
	padding: 10px 12px;
	border-radius: 4px;
	margin-top: 4px;
	border: 1px solid var(--shadingArrayBorderColor);

	&.active{
		background: var(--arrayDetailsActiveBgColor);
    border-color: var(--shadingArrayBorderColor);
	}

	.array-detail-value{
	margin-bottom: 6px;
		label, span{
			font-size: 13px;
			line-height: 16px;
		}
	}
`;

export const ArrayHeading = styled.div`
		width: 100%;
    font-size: 12px;
    font-weight: 600;
    color: var(--mutedLabelColor);
    margin-bottom: 5px;
    text-transform: uppercase;
    letter-spacing: 0.4px;
`;

export const FlexTwoCol = styled.div`
    display: grid;
		grid-template-columns: 1fr 1fr;
    gap: 8px 10px;
		width: 100%;
`;
